import { LayoutUpdateRequest, SiteControlLayout } from '@scaleaq/sitecontrol-lib';

export const getLayoutUpdateRequestFromSiteControlLayout = ({
  id,
  name,
  widgets,
}: SiteControlLayout): LayoutUpdateRequest => {
  return {
    id,
    name,
    widgets,
  };
};
